export const HOLD_MS = 3000

export type HoldSample = {
  progress: number
  unlocked: boolean
  justUnlocked: boolean
}

export class HoldGate {
  private startedAt: number | null = null
  private hasUnlocked = false

  constructor(private readonly holdMs: number = HOLD_MS) {}

  press(now: number): void {
    if (this.hasUnlocked) return
    this.startedAt = now
  }

  sample(now: number): HoldSample {
    if (this.hasUnlocked) {
      return { progress: 1, unlocked: true, justUnlocked: false }
    }
    if (this.startedAt === null) {
      return { progress: 0, unlocked: false, justUnlocked: false }
    }
    const progress = Math.min(1, (now - this.startedAt) / this.holdMs)
    const justUnlocked = progress >= 1
    if (justUnlocked) this.hasUnlocked = true
    return { progress, unlocked: this.hasUnlocked, justUnlocked }
  }

  release(now: number): 'unlocked' | 'cancelled' | 'idle' {
    if (this.startedAt === null && !this.hasUnlocked) return 'idle'
    this.sample(now)
    if (this.hasUnlocked) {
      this.startedAt = null
      return 'unlocked'
    }
    this.startedAt = null
    return 'cancelled'
  }

  reset(): void {
    this.startedAt = null
    this.hasUnlocked = false
  }
}
